import { render, staticRenderFns } from "./AtlasPublicView.vue?vue&type=template&id=5b770200&lang=true&"
import script from "./AtlasPublicView.vue?vue&type=script&lang=js&"
export * from "./AtlasPublicView.vue?vue&type=script&lang=js&"
import style0 from "./AtlasPublicView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports